// src/components/careers/HeroSection.tsx
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface HeroSectionProps {
  onOpenModal: () => void;
}

export function HeroSection({ onOpenModal }: HeroSectionProps) {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 lg:py-36 overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/40" />
        <video autoPlay loop muted playsInline className="h-full w-full object-cover">
          <source src="/oleyes_banner_video_2.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-korolev font-bold leading-tight tracking-wide text-white">
            {t('careers.title', 'Careers at Oleyes Security')}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-slate-200 max-w-3xl mx-auto">
            {t('careers.subtitle', 'Join the Innovators at Oleyes Security')}
          </p>
          <div className="mt-8">
            <Button
              onClick={onOpenModal}
              className="px-8 py-3 bg-white text-slate-900 font-bold rounded-full hover:bg-slate-100 transition-colors duration-300 text-lg"
            >
              {t('careers.cta.button', 'View Open Positions')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}